module.exports = __webpack_public_path__ + "img/planmonterad.7f44d0b1.png";